export default __webpack_public_path__ + "static/media/Coconut.0567d39a.png";